/**
 * HistopathologyTabs.js - Tab config for Histopathology routes (aligned with admin4.0).
 * Uses dummy screens from src/HistoModule (Home, Specimen, Reporting, etc.).
 */
import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// HistoModule – Home (Billing)
import NewBill from "../HistoModule/Home/NewBill";
import ExistingBill from "../HistoModule/Home/ExistingBill";
import Outsource from "../HistoModule/Home/Outsource";
import HistopathologyReport from "../HistoModule/Home/HistopathologyReport";
import Demographics from "../HistoModule/Home/Demographics";
import HistopathologyQuickBilling from "../HistoModule/Home/HistopathologyQuickBilling";
// HistoModule – Billing
import HospitalBilling from "../HistoModule/Billing/HospitalBilling";
import CashCounter from "../HistoModule/Billing/CashCounter";
// HistoModule – Specimen
import SpecimenCollection from "../HistoModule/Specimen/SpecimenCollection";
import OutsourceTest from "../HistoModule/Specimen/OutsourceTest";
// HistoModule – Reporting
import PendingList from "../HistoModule/Reporting/PendingList";
import ApprovalList from "../HistoModule/Reporting/ApprovalList";
import CompletedList from "../HistoModule/Reporting/CompletedList";
// HistoModule – CreditSettlement
import CorporateProvider from "../HistoModule/CreditSettlement/CorporateProvider";
import CorporateIndividualPayment from "../HistoModule/CreditSettlement/CorporateIndividualPayment";
// HistoModule – Reports
import BillReport from "../HistoModule/Reports/BillReport";
import PatientDemographicsReport from "../HistoModule/Reports/PatientDemographicsReport";
import OutsourceReport from "../HistoModule/Reports/OutsourceReport";
import TATReport from "../HistoModule/Reports/TATReport";
// HistoModule – Masters
import HistopathologyConfigHome from "../HistoModule/Masters/HistopathologyConfigHome";
import RoleAccess from "../HistoModule/Masters/UserConfiguration/RoleAccess";
import UserConfig from "../HistoModule/Masters/UserConfiguration/UserConfig";
import AddRoleAccess from "../HistoModule/Masters/UserConfiguration/AddRoleAccess";
import ServiceMaster from "../HistoModule/Masters/ServiceMaster";
import ResultTemplate from "../HistoModule/Masters/ResultTemplate";
import SpecimenMaster from "../HistoModule/Masters/SpecimenMaster";
import OutSourceConfiguration from "../HistoModule/Masters/OutSourceConfiguration";
import ESignConfiguration from "../HistoModule/Masters/eSignConfiguration";
import ReferredDoctor from "../HistoModule/Masters/ReferredDoctor";
import DemographicsLayout from "../HistoModule/Masters/DemographicsLayout";
import CustomConfiguration from "../HistoModule/Masters/CustomConfiguration";
import AddResultTemplate from "../HistoModule/Masters/AddResultTemplate";
import CorporateConfiguration from "../HistoModule/Masters/CorporateConfiguration";

export { HistopathologyConfigHome, CorporateIndividualPayment };

export const HistoPlaceholder = ({ label }) => (
  <Box sx={{ p: 2 }}>
    <Typography variant="h6" color="text.secondary">Histopathology – {label}</Typography>
  </Box>
);

export const Histopathology_Tabs = {
  Histopathology_Home_Tabs: [
    { id: 1, menuName: "New Bill", component: <NewBill />, subMenu: [], path: "/HistopathologyHome/NewBill" },
    { id: 2, menuName: "Existing Bill", component: <ExistingBill />, subMenu: [], path: "/HistopathologyHome/ExistingBill" },
  ],
  Histopathology_Result_Tabs: [
    { id: 1, menuName: "Histopathology Report", component: <HistopathologyReport />, subMenu: [], path: "/HistopathologyHome/HistopathologyReport" },
    { id: 2, menuName: "Demographics", component: <Demographics />, subMenu: [], path: "/HistopathologyHome/Demographics" },
  ],
  Histopathology_Quick_Billing_Tabs: [
    { id: 1, menuName: "Histopathology Billing", component: <HistopathologyQuickBilling />, subMenu: [], path: "/HistopathologyHome/HistopathologyQuickBilling" },
  ],
  Histopathology_Billing_Tabs: [
    { id: 1, menuName: "Hospital Billing", component: <HospitalBilling />, subMenu: [], path: "/HistopathologyBilling/HospitalBilling" },
    { id: 2, menuName: "Cash Counter", component: <CashCounter />, subMenu: [], path: "/HistopathologyBilling/CashCounter" },
  ],
  Histopathology_Credit_Settle_Tabs: [
    { id: 1, menuName: "Hospital Provider", component: <CorporateProvider />, subMenu: [], path: "/HistopathologyCreditSettlement/CorporateProvider" },
  ],
  Histopathology_Reports_Tabs: [
    { id: 1, menuName: "Bill Report", component: <BillReport />, subMenu: [], path: "/HistopathologyReports/BillReport" },
    { id: 2, menuName: "Patient Demographics Report", component: <PatientDemographicsReport />, subMenu: [], path: "/HistopathologyReports/PatientDemographicsReport" },
    { id: 3, menuName: "Outsource Report", component: <OutsourceReport />, subMenu: [], path: "/HistopathologyReports/OutsourceReport" },
    { id: 4, menuName: "TAT Report", component: <TATReport />, subMenu: [], path: "/HistopathologyReports/TATReport" },
  ],
  Histopathology_Settings_Tabs: [
    { id: 1, menuName: "Service Master", component: <ServiceMaster />, subMenu: [], path: "/HistopathologySetting/MasterConfiguration/ServiceMaster" },
    { id: 2, menuName: "Result Template", component: <ResultTemplate />, subMenu: [], path: "/HistopathologySetting/MasterConfiguration/ResultTemplate" },
    { id: 3, menuName: "Specimen Master", component: <SpecimenMaster />, subMenu: [], path: "/HistopathologySetting/MasterConfiguration/SpecimenMaster" },
  ],
  Histopathology_Clinic_Tabs: [
    { id: 1, menuName: "Demographics Layout", component: <DemographicsLayout />, subMenu: [], path: "/HistopathologySetting/ClinicConfiguration/DemographicsLayout" },
    { id: 2, menuName: "Outsource Configuration", component: <OutSourceConfiguration />, subMenu: [], path: "/HistopathologySetting/ClinicConfiguration/OutSourceConfiguration" },
    { id: 3, menuName: "E-Sign Configuration", component: <ESignConfiguration />, subMenu: [], path: "/HistopathologySetting/ClinicConfiguration/eSignConfiguration" },
    { id: 4, menuName: "Referred Doctor", component: <ReferredDoctor />, subMenu: [], path: "/HistopathologySetting/ClinicConfiguration/ReferredDoctor" },
    { id: 5, menuName: "Custom Configuration", component: <CustomConfiguration />, subMenu: [], path: "/HistopathologySetting/ClinicConfiguration/CustomConfiguration" },
    { id: 6, menuName: "Hospital Configuration", component: <CorporateConfiguration />, subMenu: [], path: "/HistopathologySetting/ClinicConfiguration/CorporateConfiguration" },
  ],
  Histopathology_User_Tabs: [
    { id: 1, menuName: "Role Access", component: <RoleAccess />, subMenu: [], path: "/HistopathologySetting/UserConfiguration/RoleAccess" },
    { id: 2, menuName: "User Configuration", component: <UserConfig />, subMenu: [], path: "/HistopathologySetting/UserConfiguration/UserConfig" },
  ],
  Histopathology_Add_RoleAccess: [
    { id: 1, menuName: "Add Role", component: <AddRoleAccess />, subMenu: [], path: "/HistopathologySetting/UserConfiguration/RoleAccess/Add" },
  ],
  Histopathology_Add_Template: [
    { id: 1, menuName: "Add Result Template", component: <AddResultTemplate />, subMenu: [], path: "/HistopathologySetting/MasterConfiguration/ResultTemplate/Add" },
  ],
  Histopathology_Specimen_Tabs: [
    { id: 1, menuName: "Specimen Collection", component: <SpecimenCollection />, subMenu: [], path: "/HistopathologySpecimen/SpecimenCollection" },
    { id: 2, menuName: "Outsource Test", component: <OutsourceTest />, subMenu: [], path: "/HistopathologySpecimen/OutsourceTest" },
  ],
  Histopathology_Reporting_Tabs: [
    { id: 1, menuName: "Pending List", component: <PendingList />, subMenu: [], path: "/HistopathologyReporting/PendingList" },
    { id: 2, menuName: "Approval List", component: <ApprovalList />, subMenu: [], path: "/HistopathologyReporting/ApprovalList" },
    { id: 3, menuName: "Completed List", component: <CompletedList />, subMenu: [], path: "/HistopathologyReporting/CompletedList" },
  ],
};
